import { Gateway } from './gateway'
export { Fetch as FetchGateway } from './fetch'
export { HTTP as HTTPGateway } from './http'
export { Mock as MockGateway } from './mock'
export { isTimeoutError, createTimeoutError } from './timeout-error'
export { XHR as XHRGateway } from './xhr'
export type { HTTPRequestParams, HTTPGatewayConfiguration, GatewayConfiguration } from './types'
export default Gateway
export { Gateway }
